interface ChipOption<V extends string> {
  value: V;
  label: string;
}

interface Props<V extends string> {
  value: V;
  options: readonly ChipOption<V>[];
  onChange: (v: V) => void;
  size?: 'sm' | 'md';
}

export function FilterChips<V extends string>({ value, options, onChange, size = 'md' }: Props<V>) {
  const dim = size === 'sm' ? 'h-6 px-2 text-[11px]' : 'h-7 px-3 text-xs';
  return (
    <div className="inline-flex flex-wrap gap-1">
      {options.map((opt) => {
        const active = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            aria-pressed={active}
            onClick={() => onChange(opt.value)}
            className={[
              'inline-flex items-center rounded-pill font-medium transition-all focus:outline-none focus-visible:shadow-focus-accent',
              dim,
              active
                ? 'bg-kalkuel-ink text-white shadow-card'
                : 'bg-white text-kalkuel-primary border border-kalkuel-border hover:border-kalkuel-accent-strong hover:text-kalkuel-accent-strong',
            ].join(' ')}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
